import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext.js';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ReactComponent as Logo } from '../../assets//logo.svg';
import { CircularProgress } from '@mui/material';
import { useNavigate } from "react-router-dom";
import Alert from '@mui/material/Alert';
import { toast } from 'sonner';


function Copyright(props) {
    return (
        <Typography variant="body1" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https:/ilead.swiss/">
                <Logo style={{ width: "45px" }} />
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>

    );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function ForgotPassword() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [email, setEmail] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(apiUrl + '/users/forgot-password', {
                email
            });
            toast.success("If an account with this email exists, a password reset link has been sent. Please check your inbox.");

            //console.log('Login successful:', token.result);
        } catch (err) {

        } finally {

        }
    };

    useEffect(() => {
        document.title = "Forgot Password - iLead CRM";
    }, [])

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >

                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockResetOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Forgot password
                    </Typography>
                    <Box component="form" id="forgotpassword" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                        />


                        <Button
                            type="submit"
                            form="forgotpassword"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Submit
                        </Button>
                        <Grid container>
                            <Grid item>
                                <Link href="/signin" variant="body2">
                                    ← Sign In
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>

                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}